import { render, staticRenderFns } from "./quotaSummary.vue?vue&type=template&id=76958f77&scoped=true&"
import script from "./quotaSummary.vue?vue&type=script&lang=js&"
export * from "./quotaSummary.vue?vue&type=script&lang=js&"
import style0 from "./quotaSummary.vue?vue&type=style&index=0&id=76958f77&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76958f77",
  null
  
)

export default component.exports